
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Supervision for Behavioural Professionals`}</h1>
    <p>{`OpenABA is a community-driven effort to create telehealth tools that enable behavior analysts to provide digitized session with ease. `}</p>
    <p>{`To meet this need, we invest in our volunteers through mentorship. For volunteers seeking BACB certification, we are happy to provide supplemental group supervision.`}</p>
    <p>{`Our 30 hour supervision curricula is tailored to develop skills that behavior analysts need to be effective trainers, researchers, and communicators.`}</p>
    <p><strong parentName="p">{`And our supervision curricula is provided to volunteers for free!`}</strong></p>
    <p>{`If you are interested in this opportunity, please write to us at the below email address and mention that you are looking for supervision:`}</p>
    <a href="mailto:volunteer@openaba.com">volunteer@openaba.com</a>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;